export const apiBaseUrl = 'https://app.unlockb2b.com/api/signup';
